import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SearchService } from '../../search/search.service';
import { PCDB } from '../../search/search-service-types';
import { Config } from '../../config/env.config';


import { PartTypesSearchModel } from './part-types-search.model';
import {catchError, map} from 'rxjs/operators';


@Injectable()
export class PartTypesSearchService extends SearchService {

  // extendable fields:
  filtersStub: any = {};
  filterPlaceholders: any = {};
  searchModel: PartTypesSearchModel = new PartTypesSearchModel();
  serviceType = PCDB;
  idField = 'itemId';

  filtersModel: any = {
    partCategory: [],
    partSubCategory: [],
  };

  getSearchURI(): string {
    return '/part-terminology/search';
  }

  getSearchPartCategories(searchModel: PartTypesSearchModel): Observable<any> {
    // todo: empty request leads to 504
    const searchQueryString: string =
      'search=' + searchModel.searchValue +
      '&partTermId=' + searchModel.partTermId;
    return this.http.get(`${Config.API}/category/search?${searchQueryString}`)

      .pipe(map( (res: Array<{
          option: string,
          title: string,
        }>) => {
        return res;
      }),
      catchError(this.handleError.bind(this)));
  }

  getSearchPartSubcategories(searchModel: PartTypesSearchModel): Observable<any> {
    const searchQueryString = `categoryId=${searchModel.categoryId}`;
    return this.http.get(`${Config.API}/sub-category/search?${searchQueryString}`)

      .pipe(map( (res) => {
        return res;
      }),
      catchError(this.handleError.bind(this)));
  }

  getQueryString(searchModel: PartTypesSearchModel): string {
    const sortCol: string = (searchModel.sortModel) ? searchModel.sortModel.column : '';
    const sortDir: string = (searchModel.sortModel) ? searchModel.sortModel.sort : '';

    const queryString: string =
      'page=' + searchModel.currentPage +
      '&categoryId=' + searchModel.categoryId +
      '&subCategoryId=' + searchModel.subCategoryId +
      '&partTermId=' + searchModel.partTermId +
      '&itemsPerPage=' + searchModel.itemsPerPage +
      '&search=' + searchModel.searchValue +
      '&sortCol=' + sortCol +
      '&sortDir=' + sortDir;

    return queryString;
  }

  runSearch(brandId: string, searchModel: PartTypesSearchModel): Observable<any> {
    this.searchModel = searchModel;
    const searchUri: string = this.getSearchURI();
    const searchQueryString: string = this.getQueryString(searchModel);

    return this.http.get(`${Config.API}${searchUri}?${searchQueryString}`)

      .pipe(map( (res) => {
        this.updateData(res);
        return res;
      }), catchError(this.handleError.bind(this)));
  }
}
